import HeroSimplev2 from './HeroSimplev2'
export default HeroSimplev2
